import { createStyles, rem } from '@mantine/core'

type StyleParams = {
  backgroundColor: string
}

export default createStyles((theme, { backgroundColor }: StyleParams) => {
  return {
    root: {
      backgroundColor: backgroundColor || theme.colors.gray[1],
    },
    header: {
      color: theme.colors.gray[8],
      padding: `${rem(24)} 0`,
      [theme.fn.largerThan('sm')]: {
        textAlign: 'center',
        padding: `${rem(48)} 0`,
      },
    },
  }
})
